import script from "./VInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./VInput.vue?vue&type=script&lang=ts&setup=true"

import "./VInput.vue?vue&type=style&index=0&id=9d594e3e&lang=sass"

const __exports__ = script;

export default __exports__